// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.components-CompanyDetails-KycStatusChip___kycApproved--lSzLQ {
  height: 32px;
  font-size: 13px;
  color: #ffffff;
  letter-spacing: 0;
  background: #4caf50;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  margin: 0 16px 0 0;
  font-family: 'Roboto';
  font-weight: 600;
}

.components-CompanyDetails-KycStatusChip___kycNotApproved--t9lcV {
  height: 32px;
  font-size: 13px;
  color: #ffffff;
  letter-spacing: 0;
  background: #ff9800;
  border-radius: 4px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0 16px;
  margin: 0 16px 0 0;
  font-family: 'Roboto';
  font-weight: 600;
}
`, "",{"version":3,"sources":["webpack://./components/CompanyDetails/KycStatusChip.pcss"],"names":[],"mappings":"AAAA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,YAAY;EACZ,eAAe;EACf,cAAc;EACd,iBAAiB;EACjB,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,kBAAkB;EAClB,qBAAqB;EACrB,gBAAgB;AAClB","sourcesContent":[".kycApproved {\n  height: 32px;\n  font-size: 13px;\n  color: #ffffff;\n  letter-spacing: 0;\n  background: #4caf50;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 16px;\n  margin: 0 16px 0 0;\n  font-family: 'Roboto';\n  font-weight: 600;\n}\n\n.kycNotApproved {\n  height: 32px;\n  font-size: 13px;\n  color: #ffffff;\n  letter-spacing: 0;\n  background: #ff9800;\n  border-radius: 4px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 16px;\n  margin: 0 16px 0 0;\n  font-family: 'Roboto';\n  font-weight: 600;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"kycApproved": `components-CompanyDetails-KycStatusChip___kycApproved--lSzLQ`,
	"kycNotApproved": `components-CompanyDetails-KycStatusChip___kycNotApproved--t9lcV`
};
module.exports = ___CSS_LOADER_EXPORT___;
